import { State2Way } from "@/decorators";

import moment from "moment-timezone";

import { get } from "lodash";

import { User } from "../../store/store";

import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Ref } from "vue-facing-decorator";
import { AccountingPeriod } from "../../../../types";

@Component
export class CheckBase extends Vue {
    @Prop({ default: "" }) accountingPeriodId: string;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) acKey: string;

    @Ref("generalLedger") generalLedger;

    auditCheckResultId: string = "";

    openChat: boolean = false;

    displayActivityDialog: boolean = false;

    activity: any;

    accountableAccountsRoot: string[] = [];

    showNm1: boolean = false;

    @State2Way("updateAccountingPeriods", "accountingPeriod.accountingPeriods")
    accountingPeriods!: any[];

    @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    accountingPeriod!: any;

    @State2Way("updateAccountingPeriodReadOnly", "accountingPeriod.readonly")
    readonly!: boolean;

    get accountingPeriodsList() {
        const accountingPeriods = [];
        if (!this.$store?.state?.accountingPeriod?.accountingPeriods?.length) {
            return accountingPeriods;
        }

        for (const accountingPeriod of this.$store.state.accountingPeriod.accountingPeriods) {
            if (accountingPeriod.accountingSituations?.length) {
                accountingPeriods.push(
                    ...accountingPeriod.accountingSituations.map((as) => {
                        return {
                            text:
                                moment(as.start).format("DD/MM/YYYY") +
                                " - " +
                                moment(as.end).format("DD/MM/YYYY") +
                                " (Situation)",
                            value: as.id,
                        };
                    }),
                );
            }
            accountingPeriods.push({
                text:
                    moment(accountingPeriod.start).format("DD/MM/YYYY") +
                    " - " +
                    moment(accountingPeriod.end).format("DD/MM/YYYY"),
                value: accountingPeriod.id,
            });
        }

        return accountingPeriods;
    }

    glAccountingPeriod_ = null;

    get glAccountingPeriod() {
        if (this.glAccountingPeriod_) {
            return this.glAccountingPeriod_;
        }
        return this.accountingPeriodId;
    }

    set glAccountingPeriod(data) {
        this.glAccountingPeriod_ = data;
    }

    userAccountableAccountsRoot = [];

    get glAccountableAccountsRoot() {
        if (this.userAccountableAccountsRoot.length) {
            return this.userAccountableAccountsRoot;
        }
        return this.accountableAccountsRoot;
    }

    set glAccountableAccountsRoot(data) {
        this.userAccountableAccountsRoot = data;
    }

    get chatId() {
        if (!this.accountingPeriodId || !this.acKey) {
            return null;
        }
        return this.acKey + "_" + this.accountingPeriodId;
    }

    get currentUser(): User {
        return this.$store?.state?.user || null;
    }

    get nextControl() {
        if (
            !this.$store?.state ||
            !this.$store.state.auditReport.previousNextFilteredControls?.length
        ) {
            return null;
        }
        const currentIndex = this.$store.state.auditReport.previousNextFilteredControls?.findIndex(
            (control) => control.key === this.acKey,
        );
        if (currentIndex === -1) {
            return null;
        } else {
            let nextControl =
                this.$store.state.auditReport.previousNextFilteredControls[currentIndex + 1];
            if (!nextControl) {
                return null;
            }
            let count = 1;
            if (!nextControl.key) {
                while (!nextControl.key) {
                    if (
                        currentIndex + count >
                        this.$store.state.auditReport.previousNextFilteredControls.length
                    ) {
                        return null;
                    }
                    nextControl =
                        this.$store.state.auditReport.previousNextFilteredControls[
                            currentIndex + count
                        ];
                    count++;
                }
            }
            return nextControl;
        }
    }

    get previousControl() {
        if (
            !this.$store?.state ||
            !this.$store.state.auditReport.previousNextFilteredControls?.length
        ) {
            return null;
        }
        const currentIndex = this.$store.state.auditReport.previousNextFilteredControls?.findIndex(
            (control) => control.key === this.acKey,
        );
        if (currentIndex === -1) {
            return null;
        } else {
            let previousControl =
                this.$store.state.auditReport.previousNextFilteredControls[currentIndex - 1];
            if (!previousControl) {
                return null;
            }

            let count = 1;
            if (!previousControl.key) {
                while (!previousControl.key) {
                    if (currentIndex - count < 0) {
                        return null;
                    }
                    previousControl =
                        this.$store.state.auditReport.previousNextFilteredControls[
                            currentIndex - count
                        ];
                    count++;
                }
            }
            return previousControl;
        }
    }

    get isEnableReview() {
        return get(this.currentUser, "profile.configuration.auditReport.enableReview", false);
    }

    _mounted() {
        this.readonly = true;
        // this.initializeUserActivity() // deprecated
    }

    beforeDestroy() {
        this.readonly = false;
    }

    // initializeUserActivity(action = undefined) { // deprecated
    //     if (!action) {
    //         action = this.auditCheckResultId ? "UPDATE" : "CREATE"
    //     }
    //     this.activity = new UserActivity(action, "AUDIT_CHECK_RESULT", moment())
    // }

    searchAccountingPeriod() {
        const intervalId = setInterval(() => {
            if (this.accountingPeriods.length) {
                clearInterval(intervalId);
                this.accountingPeriod = this.accountingPeriods.find(
                    (ap) => ap.id === this.accountingPeriodId,
                );
                this.afterAccountingPeriodFound();
            }
        }, 200);
    }

    afterAccountingPeriodFound() {}

    openAudit(auditCheck) {
        if (auditCheck.action) {
            const location: any = {
                name: auditCheck.action.pathName,
            };
            if (auditCheck.action.params) {
                location.params = auditCheck.action.params;
            } else {
                location.params = {
                    companyId: this.companyId,
                    accountingPeriodId: this.accountingPeriodId,
                    acKey: auditCheck.key,
                };
            }

            this.$router.push(location);
            return;
        }
        return auditCheck.pathName ? this.openControl(auditCheck) : this.openAction(auditCheck);
    }

    // ** used with manual & salaryCommons
    // ** needs this.addActionData(report) in getAuditReportData
    openAction(check) {
        if (check?.comments[0]?.pathName) {
            const location: any = {
                name: check.comments[0].pathName,
            };
            if (check?.params) {
                location.params = check.params;
            } else {
                location.params = {
                    companyId: this.companyId,
                    accountingPeriodId: this.accountingPeriodId,
                    acKey: check.key,
                };
            }

            this.$router.push(location);
        }
    }

    // ** all other audits
    openControl(control) {
        if (control.pathName) {
            this.$router.push({
                name: control.pathName,
                params: {
                    companyId: this.companyId,
                    accountingPeriodId: this.accountingPeriodId,
                    acKey: control.key,
                },
            });
        }
    }

    goToPreviousControl() {
        this.openAudit(this.previousControl);
    }

    goToNextControl() {
        this.openAudit(this.nextControl);
    }

    // async createUserActivity(action: string) {  // deprecated
    //     debugger
    //     if (!action) {
    //         action = this.auditCheckResultId ? "UPDATE" : "CREATE"
    //     }
    //     try {
    //         await this.activity.create(this.$apollo, this.currentUser.id, this.companyId, this.acKey, action, this.accountingPeriodId)
    //         this.initializeUserActivity(action)
    //     } catch(e) {
    //         console.error(e)
    //     }
    // }
}

export default toNative(CheckBase);
